import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

import { InstructionsProvider } from "@/routes/simulator/context/instructions";

import { useSimulator } from "../simulator/context/SimulatorWrapper";
import { VersionInformationPage } from "./version-information-page";

import { toast } from "sonner";

export const VersionInformationRoute: React.FC = () => {
  const { versionId } = useParams();

  const { releasesWithVersions } = useSimulator();

  const version = useMemo(() => {
    return releasesWithVersions?.find((r) => +r.id === Number(versionId));
  }, [releasesWithVersions, versionId]);

  if (!version) {
    toast.error("Version not found, please try another version");
    return null;
  }

  return (
    <InstructionsProvider>
      <VersionInformationPage version={version} />
    </InstructionsProvider>
  );
};
